import React from 'react'
import Icon from './icon';

const IconSmall = ({...props}) => (
  <Icon style={{width: "6em", padding: "1.1em"}} {...props} />
)

export default IconSmall